export class ChartEnvironment {
  public static getName = () => 'benzinga-chart';
  public static getEnvironment = (env: Record<string, string>) => ({
    barsKey: env.barsKey ?? '',
    barsUrl: new URL(env.barsUrl ?? 'https://api.benzinga.com/api/'),
    cryptoUrl: new URL(env.cryptoUrl ?? 'https://www.benzinga.com/'),
    embedChartUrl: env.embedChartUrl ?? 'https://widgets.benzinga.com/',
    key: env.key ?? '',
    socketUrl: new URL(env.socketUrl ?? 'wss://pro-charts.benzinga.com/quotes/socket'),
    url: new URL(env.url ?? 'https://data-api-pro.benzinga.com/rest/'),
  });
}
